import { render, staticRenderFns } from "./BlockRow.vue?vue&type=template&id=59e04bd9"
import script from "./BlockRow.vue?vue&type=script&lang=js"
export * from "./BlockRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports